__turbopack_context__.v({
  "content": "hdzZnW_content",
  "entryAnimation": "hdzZnW_entryAnimation",
  "image": "hdzZnW_image",
  "root": "hdzZnW_root",
  "section-1": "hdzZnW_section-1",
  "section-2": "hdzZnW_section-2",
  "social-btns": "hdzZnW_social-btns",
  "text": "hdzZnW_text",
});
